/**
 * @file 远程加载语言包
 * @author svon.me@gmail.com
 */


import {setValue} from "./cache";
import * as LanguageData from "./language";
import safeGet from "@fengqiaogang/safe-get";
import * as language from "src/utils/language";

export const getLanguage = function (): string {
  return language.currentType();
}

export const load = async function () {
  const key = language.currentType();
  const type = String(key).replace(/\W/ig, "");
  const temp = safeGet<Function>(LanguageData, type);
  if (temp) {
    const module = await temp();
    let value;
    if (module && module.default) {
      value = module.default
    } else {
      value = module;
    }
    setValue(key, safeGet(value, key) || {});
  }
}
